'use strict';

module.exports = {
    ELECTRON_MASS: 5.48579909070e-4
};
